const development_tenant = {
    notification: 'شما در حالت توسعه هستید.',
};
export default Object.freeze(development_tenant);
